'use strict';
import classNames from 'classnames';
import get from 'lodash/get';
import * as T from 'prop-types';
import React, {Fragment} from 'react';
import {ValidationErrorMessages} from '../../../../../components/forms/ValidationErrorMessages';
import {I18nComponent} from '../../../../../core-utilities/react-i18n';


export function BaseDurationFieldEditView(props) {
  const result = props.value;
  return (
    <Fragment>
      <div
        className={classNames("DurationFieldEdit", {
          DurationFieldEdit_saving: props.isSaving,
          DurationFieldEdit_error: get(props.validationMessages, 'length'),
        })}
      >
        <div className="DurationFieldEdit__labelContent">
          <div className="DurationFieldEdit__inputWrapper">
            <input
              type="number"
              className="DurationFieldEdit__input"
              placeholder={props.inputPlaceholder}
              value={result.value || 0}
              onChange={props.onChange}
              disabled={props.isSaving}
            />
          </div>
          <div className="DurationFieldEdit__selectWrapper">
            <select
              className="DurationFieldEdit__select"
              value={result.unit}
              onChange={props.onChangeSelect}
              disabled={props.isSaving}
            >
              <option value="seconds">
                {props.secondsLabel}
              </option>
              <option value="minutes">
                {props.minutesLabel}
              </option>
              <option value="hours">
                {props.hoursLabel}
              </option>
              <option value="days">
                {props.daysLabel}
              </option>
              <option value="weeks">
                {props.weeksLabel}
              </option>
              <option value="years">
                {props.yearsLabel}
              </option>
            </select>
          </div>
        </div>
      </div>
      <ValidationErrorMessages validationMessages={props.validationMessages} />
    </Fragment>
  );
}

BaseDurationFieldEditView.propTypes = {
  field: T.object.isRequired,
  isSaving: T.bool.isRequired,
  onChange: T.func.isRequired,
  value: T.object.isRequired,
  validationMessages: T.arrayOf(T.string),
  inputPlaceholder: T.string,

  secondsLabel: T.string,
  minutesLabel: T.string,
  hoursLabel: T.string,
  daysLabel: T.string,
  weeksLabel: T.string,
  yearsLabel: T.string,
};

export const DurationFieldEditView = I18nComponent(BaseDurationFieldEditView, [
  {code: 'default.input.placeholder', prop: 'inputPlaceholder'},
  {code: 'forms.duration.options.units.seconds.label', prop: 'secondsLabel'},
  {code: 'forms.duration.options.units.minutes.label', prop: 'minutesLabel'},
  {code: 'forms.duration.options.units.hours.label', prop: 'hoursLabel'},
  {code: 'forms.duration.options.units.days.label', prop: 'daysLabel'},
  {code: 'forms.duration.options.units.weeks.label', prop: 'weeksLabel'},
  {code: 'forms.duration.options.units.years.label', prop: 'yearsLabel'},
]);



// WEBPACK FOOTER //
// ./src/js/form-builder/components/response/fields/DurationFieldEdit/DurationFieldEditView.js